import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import publicAxios from "../utils/publicAxios";
import {
  getMonthyCommsnReportURL,
  getReferralTableURL,
  getMonthlyReportEmailUrl,
  getMonthlyReportUrl,
  getReferrerListUrl,
  getMonthlyReportDownloadURL,
  getEmailContentMonthlyCommisonURL,
  getreferralImageURL,
  getMonthlyCommReportURL,
  getMonthlyReportMarkPaidURL,
  getAllEmailContentMonthlyCommisonURL,
  getMonthlyCreatePaymentURL,
  getReferralTableDeleteURL,
  getUserSalesLeadPersonUrl,
  userReferralPartnerUrl,
  getCustomerReferralURL,
  getMonthlyComissionInvoicePopupUrl
} from "../utils/constants/apiEndPoints";
import { showToastType } from "../utils/constants/appConstants";
import { showToast } from "../utils/utils";
import { reffPartner } from "../locales/en";
import { HTTP_STATUS_SUCCESS } from "../utils/constants/appConstants";

const initialState = {
  partnerManageLoading: false,
  monthlyReportingLoading: false,
  monthlyCommisonReportLoading: false,
  referralPartnerPageLoad: false,
  userReferralPartner: null,
  monthlycomisionData: [],
  referralCustomerLoad: false,
  referralCustomerData: [],
  monthlycomisionInvoicePopupData: null,
  monthlycomisionInvoicePopupLoad: false
};

const referraPartnerSlice = createSlice({
  name: "referralPartner",
  initialState,
  reducers: {
    setPartnerManageLoading(state, action) {
      state.partnerManageLoading = action.payload;
    },
    setMonthlyReportingLoading(state, action) {
      state.monthlyReportingLoading = action.payload;
    },
    setMonthlyCommisonReportLoading(state, action) {
      state.monthlyCommisonReportLoading = action.payload;
    },
    setUserReferralPartner(state, action) {
      state.userReferralPartner = action.payload;
    },
    setMonthlyComisionReportData(state, action) {
      state.monthlycomisionData = action.payload;
    },
    clearMonthlyComisionInvoicePopupData(state) {
      state.monthlycomisionInvoicePopupData = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReferralTableDeleteThunk.fulfilled, () => {
        showToast(
          reffPartner?.partnermanage.table.alert.item3,
          showToastType.success
        );
      })
      .addCase(getReferralTableDeleteThunk.rejected, (_, action) => {
        if (action.payload.status === 404) {
          showToast(action.payload.data.errors, showToastType.error);
        } else {
          showToast(
            reffPartner?.partnermanage.table.alert.item4,
            showToastType.error
          );
        }
      })

      // Partner Management Add CAse
      .addCase(getReferralTableThunk.pending, (state) => {
        state.partnerManageLoading = true;
      })
      .addCase(getReferralTableThunk.fulfilled, (state) => {
        state.partnerManageLoading = false;
      })
      .addCase(getReferralTableThunk.rejected, (state) => {
        state.partnerManageLoading = false;
      })

      // Monthly Reporting Add CAse
      .addCase(getMonthlyReportThunk.pending, (state) => {
        state.monthlyReportingLoading = true;
      })
      .addCase(getMonthlyReportThunk.fulfilled, (state) => {
        state.monthlyReportingLoading = false;
      })
      .addCase(getMonthlyReportThunk.rejected, (state) => {
        state.monthlyReportingLoading = false;
      })

      // Monthly Commisn Report Add CAse
      .addCase(getMonthlyCommisonReportThunk.pending, (state) => {
        state.monthlyCommisonReportLoading = true;
      })
      .addCase(getMonthlyCommisonReportThunk.fulfilled, (state) => {
        state.monthlyCommisonReportLoading = false;
      })
      .addCase(getMonthlyCommisonReportThunk.rejected, (state) => {
        state.monthlyCommisonReportLoading = false;
      })

      // referralPartnerImageThunk
      .addCase(referralPartnerImageThunk.pending, (state) => {
        state.referralPartnerPageLoad = true;
      })
      .addCase(referralPartnerImageThunk.fulfilled, (state) => {
        state.referralPartnerPageLoad = false;
      })
      .addCase(referralPartnerImageThunk.rejected, (state, action) => {
        state.referralPartnerPageLoad = false;
        const errorData = action.payload?.response;
        if (errorData?.status === 404) {
          window.location.href = "/404";
        }
      })

      .addCase(getReferralCustomerListData.pending, (state) => {
        state.referralCustomerLoad = true;
      })
      .addCase(getReferralCustomerListData.fulfilled, (state, action) => {
        state.referralCustomerLoad = false;
        state.referralCustomerData = action.payload?.data?.data;
      })
      .addCase(getReferralCustomerListData.rejected, (state, action) => {
        state.referralCustomerLoad = false;
        showToast(action.payload.data.errors, showToastType.error);
      })

      .addCase(getMonthlyCommisonInvoicePupupThunk.pending, (state) => {
        state.monthlycomisionInvoicePopupLoad = true;
      })
      .addCase(
        getMonthlyCommisonInvoicePupupThunk.fulfilled,
        (state, action) => {
          state.monthlycomisionInvoicePopupLoad = false;
          state.monthlycomisionInvoicePopupData = action.payload?.data;
        }
      )
      .addCase(getMonthlyCommisonInvoicePupupThunk.rejected, (state) => {
        state.monthlycomisionInvoicePopupLoad = false;
      });
  }
});

// Partner Management Table Data : Thunk
export const getReferralTableThunk = createAsyncThunk(
  "referralPartner/getReferralTableThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getReferralTableURL, {
        params: payload
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Partner Management Table Delete : Thunk
export const getSalesLeadsPersonThunk = createAsyncThunk(
  "referralPartner/getSalesLeadsPersonThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getUserSalesLeadPersonUrl);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Partner Management Table Delete : Thunk
export const getReferralTableDeleteThunk = createAsyncThunk(
  "referralPartner/getReferralTableDeleteThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(
        getReferralTableDeleteURL(payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getMonthlyCommsnReportThunk = createAsyncThunk(
  "referralPartner/getMonthlyCommsnReportThunk",
  async (payload) => {
    try {
      const response = await privateAxios.get(getMonthyCommsnReportURL, {
        params: payload
      });

      return response;
    } catch {
      // handle catch here;
    }
  }
);

export const getReferrerListThunk = createAsyncThunk(
  "referralPartner/getReferrerListThunk",
  async () => {
    try {
      const response = await privateAxios.get(getReferrerListUrl);

      return response;
    } catch {
      // handle catch here;
    }
  }
);

export const getMonthlyReportThunk = createAsyncThunk(
  "referralPartner/getMonthlyReportThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getMonthlyReportUrl, {
        params: payload
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const monthlyReportEmailThunk = createAsyncThunk(
  "referralPartner/monthlyReportEmail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getMonthlyReportEmailUrl,
        {},
        {
          params: payload
        }
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMonthlyCommisonReportThunk = createAsyncThunk(
  "referralPartner/getMonthlyCommisonReportThunk",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await privateAxios.get(getMonthlyCommReportURL, {
        params: payload
      });

      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setMonthlyComisionReportData(response.data.data.AllData));
      }

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const monthlyReportDownloadThunk = createAsyncThunk(
  "referralPartner/monthlyReportDownloadThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getMonthlyReportDownloadURL, {
        params: payload,
        responseType: "blob"
      });

      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.data instanceof Blob &&
        error.response.data.type === "application/json"
      ) {
        // Parse the blob to JSON
        const errorData = await error.response.data.text();
        const errorJson = JSON.parse(errorData);

        return rejectWithValue(errorJson);
      }

      return rejectWithValue(error);
    }
  }
);

export const monthlyCreatePaymentThunk = createAsyncThunk(
  "referralPartner/monthlyCreatePaymentThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getMonthlyCreatePaymentURL, {
        params: payload,
        responseType: "blob"
      });

      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.data instanceof Blob &&
        error.response.data.type === "application/json"
      ) {
        // Parse the blob to JSON
        const errorData = await error.response.data.text();
        const errorJson = JSON.parse(errorData);

        return rejectWithValue(errorJson);
      }

      return rejectWithValue(error);
    }
  }
);

export const monthlyCommsnMarkAsPaidThunk = createAsyncThunk(
  "referralPartner/monthlyCommsnMarkAsPaidThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(
        getMonthlyReportMarkPaidURL,
        {},
        {
          params: payload
        }
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const emailScreenViewThunk = createAsyncThunk(
  "referralPartner/emailScreenViewThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getEmailContentMonthlyCommisonURL,
        {
          params: payload
        }
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const referralPartnerImageThunk = createAsyncThunk(
  "referralPartner/referralPartnerImageThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publicAxios.get(getreferralImageURL(payload));

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const allemailScreenViewThunk = createAsyncThunk(
  "referralPartner/allemailScreenViewThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getAllEmailContentMonthlyCommisonURL,
        {
          params: payload
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk to get userReferralPartner data
export const getReferralData = createAsyncThunk(
  "referralPartner/getReferralData",
  async (_, { dispatch }) => {
    try {
      const response = await privateAxios.get(userReferralPartnerUrl);
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setUserReferralPartner(response.data.data));
      }
      return response;
    } catch {
      // handle catch here;
    }
  }
);

export const getReferralCustomerListData = createAsyncThunk(
  "referralPartner/getReferralCustomerListData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publicAxios.get(getCustomerReferralURL(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMonthlyCommisonInvoicePupupThunk = createAsyncThunk(
  "referralPartner/getMonthlyCommisonInvoicePupupThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getMonthlyComissionInvoicePopupUrl,
        {
          params: payload
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const {
  setUserReferralPartner,
  setMonthlyComisionReportData,
  clearMonthlyComisionInvoicePopupData
} = referraPartnerSlice.actions;
export default referraPartnerSlice.reducer;
